import { render, staticRenderFns } from "./AddVariable.vue?vue&type=template&id=08ccc88f&"
import script from "./AddVariable.vue?vue&type=script&lang=js&"
export * from "./AddVariable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports